import Skeleton from "react-loading-skeleton";

import "./styles.sass";

const SkeletonFooter = () => {
  return (
    <div className="SkeletonFooter">
      <div className="SkeletonFooter__top">
        <div className="SkeletonFooter__logo">
          <Skeleton width={85} height={38} />
        </div>

        <div className="SkeletonFooter__block">
          <div className="SkeletonFooter__title">
            <Skeleton width={54} height={19} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={69} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={137} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={69} height={15} />
          </div>
        </div>

        <div className="SkeletonFooter__block">
          <div className="SkeletonFooter__title">
            <Skeleton width={92} height={19} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={33} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={112} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={121} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={188} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={104} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={144} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={118} height={15} />
          </div>
        </div>

        <div className="SkeletonFooter__block">
          <div className="SkeletonFooter__title">
            <Skeleton width={92} height={19} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={137} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={123} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={190} height={15} />
          </div>
          <div className="SkeletonFooter__item">
            <Skeleton width={135} height={15} />
          </div>
        </div>

        <div className="SkeletonFooter__block">
          <div className="SkeletonFooter__title">
            <Skeleton width={125} height={19} />
          </div>
          <div className="SkeletonFooter__social">
            <Skeleton
              className="SkeletonFooter__social_item"
              width={24}
              height={24}
              count={2}
              inline
            />
          </div>
          <div className="SkeletonFooter__language">
            <Skeleton
              className="SkeletonFooter__language_icon"
              width={24}
              height={24}
            />
            <Skeleton width={58} height={15} />
          </div>
        </div>
      </div>

      <div className="SkeletonFooter__payments">
        <Skeleton width={33} height={28} />
        <Skeleton width={40} height={28} />
      </div>

      <div className="SkeletonFooter__partners">
        <div className="SkeletonFooter__partner">
          <Skeleton width={51} height={40} />
          <Skeleton width={64} height={23} />
        </div>
        <div className="SkeletonFooter__partner">
          <Skeleton width={35} height={23} />
        </div>
        <div className="SkeletonFooter__partner">
          <Skeleton width={106} height={23} />
        </div>
        <div className="SkeletonFooter__partner">
          <Skeleton width={24} height={24} />
        </div>
      </div>

      <div className="SkeletonFooter__copyrights">
        <Skeleton width="99%" height={8} />
        <Skeleton width="98%" height={8} />
        <Skeleton width="99%" height={8} />
      </div>
    </div>
  );
};

export default SkeletonFooter;
